<template>
  <section-page
    title="Lead Info Custom Fields"
    description="Custom fields are input fields you can add and arrange in the Lead Info section for all leads."
  >
    <template v-slot:right>
      <button-outlined icon-left="plus" @click="$refs.customFieldModal.open(defaultFormData)">
        New Custom Field
      </button-outlined>
    </template>

    <table-default
      :table-data="customFields"
      default-sort="order"
      empty-message="You don't have any custom fields.<br>Why don't you make one."
    >
      <b-table-column label="Order" field="order" width="80" sortable v-slot="props">
        {{ props.row.index }}
      </b-table-column>

      <b-table-column label="Name" field="label" sortable v-slot="props">
        {{ props.row.label }}
      </b-table-column>

      <b-table-column label="Type" field="type" sortable v-slot="props">
        {{ props.row.type | newEnumLabel(ENUMS.CustomFieldTypeEnum) }}
      </b-table-column>

      <b-table-column label="Options" field="options" sortable v-slot="props">
        {{ props.row.options.toString() }}
      </b-table-column>

      <b-table-column label="Default Value" field="default_value" sortable v-slot="props">
        {{ props.row.default_value }}
      </b-table-column>

      <b-table-column label="Visible" field="visible" centered sortable v-slot="props">
        <icon-default
          icon="check"
          size="is-small"
          color="is-success"
          v-if="props.row.visible"
        ></icon-default>
      </b-table-column>

      <b-table-column label="Hidden From User" field="hidden_to_user" centered sortable v-slot="props">
        <icon-default
          icon="check"
          size="is-small"
          color="is-success"
          v-if="props.row.hidden_to_user"
        ></icon-default>
      </b-table-column>

      <b-table-column cell-class="action_cell" width="120" v-slot="props">
        <button-link @click="$refs.customFieldModal.open(props.row)">Manage</button-link>
      </b-table-column>
    </table-default>

    <modal-container>
      <modal-crud-form
        ref="customFieldModal"
        title="Custom Field"
        form-component="custom-field-form">
      </modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: "LeadCustomFields",
  data() {
    return {
      defaultFormData: {
        custom_fieldable_type: ENUMS.CustomFieldableTypeEnum.Record.value,
        custom_fieldable_id: null
      }
    };
  },
  computed: {
    customFields() {
      return this.$store.getters.recordCustomFields.map((cf, index) => {
        cf.index = index + 1;
        return cf;
      });
    }
  }
}
</script>

<style scoped>

</style>
